import { PremiumPurchasePlatformModule } from '@wix/premium-purchase-platform/@sdk';
import { EclipseOfferingApiClientContext } from '../eclipse-offering.context';
const isDisabledInMonthly = feature => {
  var _feature$metadata;
  return Boolean(((_feature$metadata = feature.metadata) == null ? void 0 : _feature$metadata.disabledInMonthlyCycle) === 'true');
};
export const fetchMonthlyDisabledFeaturesQueryFn = async props => {
  const {
    httpClient,
    request: {
      productId
    }
  } = props;
  const {
    getFeaturesGrid
  } = PremiumPurchasePlatformModule.SDK.ApiClient.queries({
    httpClient
  });
  const p3Context = EclipseOfferingApiClientContext.get('p3Context');
  if (!p3Context) {
    throw new Error('P3 context is required to fetch monthly disabled features');
  }
  const featuresGridData = await getFeaturesGrid({
    productIds: [productId],
    ...p3Context
  });
  if (!featuresGridData) {
    return {
      disabledFeatures: []
    };
  }
  const uniqueIds = new Set();
  const disabledFeatures = (featuresGridData.namespaces ?? []).flatMap(namespace => (namespace.features ?? []).filter(isDisabledInMonthly)).filter(feature => {
    var _feature$values;
    return (_feature$values = feature.values) == null || (_feature$values = _feature$values[productId]) == null ? void 0 : _feature$values.available;
  }).filter(feature => {
    var _feature$content;
    const key = String((_feature$content = feature.content) == null || (_feature$content = _feature$content.name) == null ? void 0 : _feature$content.translationKey);
    if (uniqueIds.has(key)) {
      return false;
    }
    uniqueIds.add(key);
    return true;
  });
  // TODO - filter features by Geo, currently not the same in legacy ppp, this should be done in getFeaturesGrid by platform

  return {
    disabledFeatures
  };
};
//# sourceMappingURL=fetch-monthly-disabled-features.query.js.map